import { Star, Heart, Circle } from "lucide-react";
import { Label } from "@/components/ui/label";
import type { FieldRendererProps } from "./index";

const iconMap = {
  star: Star,
  heart: Heart,
  circle: Circle,
};

export function RatingField({ label, required, properties }: FieldRendererProps) {
  const max = properties.max ?? 5;
  const Icon = iconMap[properties.icon ?? "star"];

  return (
    <div className="space-y-2">
      <Label>
        {label}
        {required && <span className="ml-1 text-destructive">*</span>}
      </Label>
      <div className="flex gap-1">
        {Array.from({ length: max }, (_, i) => (
          <Icon
            key={i}
            className="h-6 w-6 text-muted-foreground/40 cursor-pointer hover:text-yellow-400 transition-colors"
          />
        ))}
      </div>
    </div>
  );
}
